import { LayerCustomType } from "@/custom-fabric";
import {
  CalendarDays,
  Clock,
  Image as ImageIcon,
  ImagePlus,
  Images,
  Layers2,
  Omega,
  Puzzle,
  QrCode,
  Slack,
  Type,
  Waves,
} from "lucide-react";

interface Props {
  type: LayerCustomType;
  size: number;
}

export default function LayerIcon({ type, size }: Props) {
  return {
    base: <Layers2 size={size} />,
    text: <Type size={size} />,
    "curved-text": <Omega size={size} />,
    "warped-text": <Waves size={size} />,
    image: <ImageIcon size={size} />,
    "custom-image": <ImagePlus size={size} />,
    "clip-art": <Images size={size} />,
    "qr-code": <QrCode size={size} />,
    calendar: <CalendarDays size={size} />,
    clock: <Clock size={size} />,
    crossword: <Puzzle size={size} />,
    "word-search": <Slack size={size} />,
  }[type];
}
